import { ComponentProps, ReactElement } from "react";
import { DrawerTitle } from "@industriousoffice/react-components";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export function PaymentDrawerTitle({
  title,
  onClose,
  children,
}: ComponentProps<typeof DrawerTitle>): ReactElement {
  const { t } = useTranslation("paymentMethods");
  return (
    <div className="payment-drawer-header">
      <DrawerTitle title={title} className="payment-drawer-title" />
      {children}
      {onClose != null && (
        <button
          type="button"
          className="payment-drawer-close"
          aria-label={t("Close payment method details")}
          onClick={onClose}
        >
          <XMarkIcon width={24} height={24} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
